import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Button } from "reactstrap";
import { useAuthContext } from "../../auth/useAuthContext";
import Loading from "../../common/Loading";
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Icon } from "../../components/Component";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { fetchUsers } from "../../redux/slices/userSlice";
//import { fetchOrders } from "../../redux/slices/orderSlice";
import KanbanBoard from "./KanbanBoard";

const Enroll = () => {
  const { user } = useAuthContext();
  const dispatch = useDispatch();
  const [dragged, setDragged] = useState(false);
  const [onSearchText, setSearchText] = useState(null);
  const [onSearch, setonSearch] = useState(true);

  const newEnroll = useSelector((state) => state.user.newEnroll);
  const newOption = useSelector((state) => state.user.newOption);
  const newInvoiced = useSelector((state) => state.user.newInvoiced);
  const newPaid = useSelector((state) => state.user.newPaid);
  const newCompleted = useSelector((state) => state.user.newCompleted);
  const fetchLoading = useSelector((state) => state.user.fetchLoading);

  // function to toggle the search option
  const toggle = () => setonSearch(!onSearch);

  useEffect(() => {
    if (onSearchText === "" || onSearchText === null) {
      dispatch(
        fetchUsers({
          params: {
            status: "new",
			
            ...(user?.role?.slug === "user" ? { user_id: user?.id } : {}),
          },
          limit: 0,
          page: 1,
         
        })
      );
		
	 dispatch(
        fetchUsers({
          params: {
            status: "option",			
            ...(user?.role?.slug === "user" ? { user_id: user?.id } : {}),
          },
          limit: 0,
          page: 1,
         
        })
      );	
		
      dispatch(
        fetchUsers({
          params: {
            status: "invoiced",
            ...(user?.role?.slug === "user" ? { user_id: user?.id } : {}),
          },
          limit: 0,
          page: 1,
        })
      );

      dispatch(
        fetchUsers({
          params: {
            status: "paid",
            ...(user?.role?.slug === "user" ? { user_id: user?.id } : {}),
          },
          limit: 0,
          page: 1,
        })
      );
	  dispatch(
        fetchUsers({
          params: {
            status: "completed",
            ...(user?.role?.slug === "user" ? { user_id: user?.id } : {}),
          },
          limit: 0,
          page: 1,
        })
      );
    }
  }, [dispatch, onSearchText, user?.id, user?.role?.slug, dragged]);

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      if (onSearchText !== null) {
        dispatch(
          fetchUsers({
            params: {
              status: "new",
              ...(user?.role?.slug === "user" ? { user_id: user?.id } : {}),
              ...(onSearchText !== ""
                ? {
                    search: onSearchText,
                  }
                : {}),
            },
            limit: 600,
            page: 1,
            
          })
        );
		 dispatch(
          fetchUsers({
            params: {
              status: "option",
              ...(user?.role?.slug === "user" ? { user_id: user?.id } : {}),
              ...(onSearchText !== ""
                ? {
                    search: onSearchText,
                  }
                : {}),
            },
            limit: 600,
            page: 1,
          })
        );
        dispatch(
          fetchUsers({
            params: {
              status: "invoiced",
              ...(user?.role?.slug === "user" ? { user_id: user?.id } : {}),
              ...(onSearchText !== ""
                ? {
                    search: onSearchText,
                  }
                : {}),
            },
            limit: 600,
            page: 1,
          })
        );

        dispatch(
          fetchUsers({
            params: {
              status: "paid",
              ...(user?.role?.slug === "user" ? { user_id: user?.id } : {}),
              ...(onSearchText !== ""
                ? {
                    search: onSearchText,
                  }
                : {}),
            },
            limit: 600,
            page: 1,
          })
        );
		dispatch(
          fetchUsers({
            params: {
              status: "completed",
              ...(user?.role?.slug === "user" ? { user_id: user?.id } : {}),
              ...(onSearchText !== ""
                ? {
                    search: onSearchText,
                  }
                : {}),
            },
            limit: 600,
            page: 1,
          })
        );
      }
    }, 3000);
    return () => clearTimeout(debounceTimer);
  }, [dispatch, onSearchText, user?.id, user?.role?.slug, dragged]);



  const columns = {
    columns: {
      "column-new-order": {
        id: "column-new-order",
        text: "NEW SIGNUP",
        theme: "light",
        patients: newEnroll?.data,
      },
	   "column-option": {
        id: "column-option",
        text: "REQUESTED/OPTIONS SENT",
        theme: "primary",
        patients: newOption?.data,
      },
      "column-invoiced": {
        id: "column-invoiced",
        text: "INVOICED",
        theme: "primary",
        patients: newInvoiced?.data,
      },
      "column-paid": {
        id: "column-paid",
        text: "ORDERED",
        theme: "warning",
        patients: newPaid?.data,
      },
	   "column-completed": {
        id: "column-completed",
        text: "RECEIVED/LINK SENT",
        theme: "warning",
        patients: newCompleted?.data,
      },
    },
    columnOrder: ["column-new-order", "column-option", "column-invoiced", "column-paid", "column-completed"],
  };


  return (
    <React.Fragment>
      <Head title="New Patient Enrollment"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>New Patient Enrollments.</BlockTitle>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <div className="card-title-group justify-end">
          <div className="card-tools me-n1">
            <ul className="btn-toolbar">
              <li>
                <Button onClick={toggle} className="btn-icon search-toggle toggle-search">
                  <Icon name="search"></Icon>
                </Button>
              </li>
              <li className="btn-toolbar-sep"></li>
            </ul>
          </div>
          <div className={`card-search search-wrap ${!onSearch ? "active" : ""}`}>
            <div className="search-content">
              <Button
                className="search-back btn-icon toggle-search"
                onClick={() => {
                  setSearchText(null);
                  toggle();
                }}
              >
                <Icon name="arrow-left"></Icon>
              </Button>
              <input
                type="text"
                className="form-control border-transparent form-focus-none"
                placeholder="Search by patient name, email or phone (after 3 seconds)"
                value={onSearchText}
                onChange={(e) => {
                  setSearchText(e.target.value);
                }}
              />
              <Button className="search-submit btn-icon">
                <Icon name="search"></Icon>
              </Button>
            </div>
          </div>
        </div>

        {fetchLoading ? (
          <Loading />
        ) : (
          <Block>
            <div className="nk-kanban">
             <KanbanBoard columns={columns} setDragged={setDragged} />
            </div>
          </Block>
        )}
      </Content>
    </React.Fragment>
  );
};

export default Enroll;